/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-datetime-picker{display:flex}ui-datetime-picker .timepicker{margin-left:10px;max-width:200px}"];
export { styles as styles };
